import { en } from './Locales/en';
import { hi } from './Locales/hi';

/**
 * Application translation locales.
 * 
 * Here we define translations for our entrie app.
 * 
 * conventions:
 * - @name Name of the file
 * - @file Exact path of the file from the source root
 */
export default {
  en: {
    translation: en,
  },
  hi: {
    translation: hi,
  },
};
